import { getSettingsTheme } from '@/utils/SettingsTheme';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';

const LivePage: React.FC = () => {
  const router = useRouter();
  const { liveId } = router.query;
  return (
    <>
      <div id="root"></div>
      <script
        dangerouslySetInnerHTML={{
          __html: `(function(d, s, id) {
              var js, fjs = d.getElementsByTagName(s)[0];
              if (d.getElementById(id)) return;
              js = d.createElement(s); js.id = id;
              js.src = "https://cdn.channelize.io/live-broadcast/embed/prod/embed.js";
              fjs.parentNode.insertBefore(js, fjs);
              window.initChannelizeLivebroadcastOptions = {
                publicKey: "${process.env.NEXT_PUBLIC_CHANNELIZE_KEY}",
                mountDiv: document.getElementById("root"),
                defaultOpen: {
                  eventId:"${liveId}"
                },
              };
            }(document, "script", "channelize-livebroadcast-id"));`,
        }}
      />
    </>
  );
};

export default LivePage;

export const getServerSideProps: GetServerSideProps = async () => {
  const settingsTheme = getSettingsTheme();

  return {
    props: {
      settingsTheme,
    },
  };
};
